// extracted by mini-css-extract-plugin
export var circle = "_2x-2";
export var icon = "_2x-a";
export var iconHighlight = "_2x-0";
export var lg = "_2x-8";
export var md = "_2x-7";
export var outline = "_2x-4";
export var sm = "_2x-6";
export var square = "_2x-1";
export var xl = "_2x-9";
export var xs = "_2x-5";
export var xxs = "_2x-3";